<template>
<el-drawer :title="drawer.title" :visible.sync="drawer.visible" size="30%">
    <div class="drawer-form">
        <el-form :model="ruleForm" :rules="rules" ref="nodeRuleForm" label-width="100px" class="ruleForm">
            <el-form-item label="父级功能" prop="parent_id">
                <el-cascader v-model="ruleForm.parent_id" :options="cascaderData" :props="{ checkStrictly: true,emitPath:false }" clearable></el-cascader>
            </el-form-item>
            <el-form-item label="名称" prop="title">
                <el-input v-model="ruleForm.title"></el-input>
            </el-form-item>
            <el-form-item label="图标" prop="icon">
                <el-select v-model="ruleForm.icon" placeholder="请选择">
                    <el-option label="请选择" value="0"></el-option>
                    <el-option v-for="(row,index) in iconList" :key="index" :label="row" :value="row"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否菜单" prop="status">
                <el-select v-model="ruleForm.ismenu" placeholder="上/下线">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="路由" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>

            <el-form-item label="上/下线" prop="status">
                <el-select v-model="ruleForm.status" placeholder="上/下线">
                    <el-option label="上线" value="1"></el-option>
                    <el-option label="下线" value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model="ruleForm.sort"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="submitForm('nodeRuleForm')">保存</el-button>
                <el-button @click="resetForm('nodeRuleForm')">重置</el-button>
            </el-form-item>
        </el-form>

    </div>
</el-drawer>
</template>

<script>
export default {
    data() {
        let iconList = ['el-icon-s-home', 'el-icon-s-custom', 'el-icon-shopping-cart-1', 'el-icon-s-check', 'el-icon-data-line', 'el-icon-s-data', 'el-icon-office-building', 'el-icon-picture-outline', 'el-icon-suitcase', 'el-icon-wallet', 'el-icon-picture-outline','el-icon-school','el-icon-wallet'];
        return {
            iconList: iconList,
            parentList: [],
            cascaderData: [],
            drawer: {
                title: '',
                visible: false
            },
            authTypeList: [{
                    id: 0,
                    title: '销售'
                },
                {
                    id: 1,
                    title: '管理员'
                },
            ],
            ruleForm: {
                id: 0,
                parent_id: 0,
                title: '',
                auth_type: '',
                sort: 0,
                is_valid: '1',
                ismenu: '1',
                status: '1',

            },
            rules: {
                title: [{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur'
                    },
                    {
                        min: 3,
                        max: 100,
                        message: '长度在 3 到 100 个字符',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    created() {
        this.getCascaderData();
    },
    methods: {
        showDrawer(options, ctype) {
            let that = this;
            if (ctype == "add") {
                this.resetForm("nodeRuleForm");
                this.drawer.title = '添加节点';
                if (options != '') {
                    this.ruleForm.parent_id = options.id;
                } else {
                    this.ruleForm.parent_id = 0;
                }
            } else {
                this.drawer.title = '编辑节点';
            }
            this.drawer.visible = true;
            if (ctype == "update") {
                let url = '/api/auth.node/read';
                this.$post(url, options).then(function (response) {
                    if (response.code == '200') {
                        that.ruleForm = response.data.row;
                        that.ruleForm.ismenu = that.ruleForm.ismenu + '';
                    } else {
                        this.$message(response.msg);
                    }
                });
            }
        },
        getCascaderData() {
            let that = this;
            let url = '/api/auth.node/cascader';
            this.$post(url).then(function (response) {
                if (response.code == '200') {
                    that.cascaderData = response.data.tree;
                } else {
                    that.$message(response.msg);
                }
            });
        },
        handleChangeCascader(e) {
            if (e[0]) {
                this.ruleForm.parent_id = e[0];
            } else {
                this.ruleForm.parent_id = 0;
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let that = this;
                    let url = '';
                    if (this.ruleForm.id == '') {
                        url = '/api/auth.node/create';
                    } else {
                        url = '/api/auth.node/save';
                    }
                    this.$post(url, this.ruleForm).then(function (response) {
                        if (response.code == '200') {
                            that.drawer.visible = false;
                            that.resetForm(formName);
                            // that.$parent.doSearch();
                            that.$emit("getTreeData");
                            that.$message.success(response.msg)
                        } else {
                            that.$message(response.msg);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.ruleForm.id = 0;
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/drawer.less');
@import url('@/assets/css/company.less');
</style>
